<ng-container *ngIf="entity">
  <ng-container *ngIf="!cornerFlag">
    <ng-container *ngIf="!isFlagged()">
      <button [ngClass]="{'mimic-link color--gray':showText, 'entity__icon':!showText}"
              (click)="openFollowUpFlagDialog()">
        <i class="fas fa-flag"></i>
        <span class="ml-0050"
              *ngIf="showText">Flag for follow-up</span>
      </button>
    </ng-container>
    <ng-container *ngIf="isFlagged()">
      <span>
        <button [ngClass]="{'mimic-link':showText, 'entity__icon':!showText}"
                (click)="openFollowUpTableDialog()">
          <i class="fas fa-flag"></i>
          <span class="ml-0050"
                *ngIf="showText">Flagged for follow-up</span>
        </button>
        <span class="color--gray ml-0025">
          (<button class="mimic-link color--red"
                  (click)="completeFollowUpFlag()">Complete</button>)
        </span>
      </span>
    </ng-container>
  </ng-container>

  <!--Template for display flag in corner-->
  <ng-container *ngIf="cornerFlag">
    <span *ngIf="isFlagged()"
          class="followup-flag--corner"
          [ngStyle]="flagStyles"
          (click)="openFollowUpTableDialog($event)"
          title="Entity is flagged for follow-up">
      <i class="fas fa-fw" [ngClass]="iconClasses"></i>
    </span>
  </ng-container>

</ng-container>
